// import ownershipMap from ""
//Event Triggers when a room list is displayed in the  Hotel Details / Select Room Page
//src/utils/datalayers/addviewItemListEvent.ts
import { v4 as uuidv4 } from "uuid";
import { getLoggedStatus } from "../helpers";
import { getAffiliationFromHotel } from "./getAffiliation";

export const addViewItemListEvent = (hotel, search, rooms, eventPage): void => {
  const brandName =
    hotel.relationships &&
    hotel.relationships.brand_id &&
    hotel.relationships.brand_id.name;
  const totalRooms = search?.rooms?.length;
  const checkinDate = new Date(search.checkin);
  const checkoutDate = new Date(search.checkout);

  const lengthOfStay = Math.ceil(
    (checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)
  );
  const totalAdults = search.rooms.reduce((sum, r) => sum + r.adults, 0);
  const totalChildren = search.rooms.reduce((sum, r) => sum + r.children, 0);
  const totalGuests = totalAdults + totalChildren;

  const loggedState = getLoggedStatus();

  window._purchaseStartPage = eventPage;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "viewitemlist",
    ecommerce: {
      event_id: uuidv4(),
      coupon: search?.promotionCode || search?.groupCode || "",
      hotel_brand: brandName,
      hotel_name: hotel.name,
      hotel_id: hotel.crs_code,
      check_in_date: search?.checkin,
      check_out_date: search?.checkout,
      adults: totalAdults,
      children: totalChildren,
      total_guest: totalGuests,
      length_of_stay: lengthOfStay,
      rooms: totalRooms,
      affiliation: getAffiliationFromHotel(hotel),
      city: hotel.address?.locality,
      list_id: "Product Listing",
      category: "Room",
      list_name: eventPage,
      loggedState: loggedState,
      items: rooms.map((room, index) => ({
        quantity: lengthOfStay,
        index: index + 1,
        item_name: room?.name,
        item_id: room?.code,
        coupon: search?.promotionCode || search?.groupCode || "",
        item_hotel_brand: brandName,
        item_hotel_name: hotel.name,
        item_hotel_id: hotel.crs_code,
        item_list_id: "Product Listing",
        item_category: "Room",
        item_list_name: eventPage,
        start_date: search?.checkin,
        end_date: search?.checkout,
        price: room?.FromRateWithFees,
        currency: room?.Currency,
        // adults: room.adults,
        // children: room.children,
        // total_guest: room.adults + room.children,
      })),
    },
  });
};
